type QueryParamValue = string | number | boolean | null | undefined;
type QueryParamInput = QueryParamValue | QueryParamInput[] | { [key: string]: QueryParamInput };

export default function queryParamsFromObject(obj: QueryParamInput, prefix = ''): string {
  return paramsArrayFromObject(obj, prefix).join('&').replace(/\.=/g, '=');
}

function paramsArrayFromObject(obj: QueryParamInput, prefix: string): string[] {
  const resArr = [];
  if (obj) {
    if (Array.isArray(obj)) {
      obj.forEach((innerObj) => resArr.push(...paramsArrayFromObject(innerObj, prefix)));
    } else if (typeof obj === 'object') {
      for (const key in obj) {
        const value = obj[key];
        resArr.push(...paramsArrayFromObject(value, `${prefix}${key}.`));
      }
    } else {
      resArr.push(`${prefix}=${obj}`);
    }
  }
  return resArr;
}
